import React from 'react';

import styled from '@emotion/styled';

interface IonSubmitTableFilter {
  filter?: string;
  setFilter: (...args: any) => void;
  filterData: { [key: string]: string };
}

export const FormFilter: React.FC<IonSubmitTableFilter> = ({
  filter,
  setFilter,
  filterData,
}) => {
  const handleFilterClick = (data: string) => {
    return setFilter(data);
  };

  return (
    <TableFilterContent>
      {Object.keys(filterData).map((data) => (
        <div
          key={data}
          className={
            filter === filterData[data] ? 'activeFilter highlight' : 'highlight'
          }
          onClick={() => handleFilterClick(filterData[data])}
        >
          <div className="label">{data}</div>
        </div>
      ))}
    </TableFilterContent>
  );
};

const TableFilterContent = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 600;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.palette.secondaryText};
  width: 12rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;

  & > .activeFilter {
    background-color: ${({ theme }) => theme.palette.brandBackdrop};
    /* border: 2px solid red; */
  }

  & > .highlight {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* border: 2px solid red; */
    padding: 0.5rem 1rem;

    &:hover {
      background-color: ${({ theme }) => theme.palette.brandBackdrop};
    }
  }

  & > * > .value {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.palette.tertiaryText};
  }
`;
